module.exports = __webpack_public_path__ + "static/media/roanoke-storefront.78ab350e.jpg";